@if (user) {
  <div>
    {{user.Name}}
  </div>

  @if (showUsername) {
    <motn-pill>{{user.Username}}</motn-pill>
  }

  @if (showMotionLogo && isMotionStaff()) {
    <span
      class="motion-staff-logo-wrapper"
      (click)="showMotionStaffInfo()"
      title="Motion Staff Member"
    >
      <i class="fak fa-motion motion-staff-logo"></i>
    </span>
  }
} @else if (fetchFailed) {
  <span>Unknown user</span>
} @else {
  <motn-spinner></motn-spinner>
}
